import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { endPoint } from "constants/server/api";
import { createFetchLogicPrototype } from "../../utils/fetchFactory";
import { createSlicePrototype } from "../../utils/sliceFactory";
import { http } from "utils/http";
var genPesDocNumberSlice = createSlicePrototype({
    name: "genPesDocNumber"
});
export var genPesDocNumber = createFetchLogicPrototype({
    actions: genPesDocNumberSlice.actions,
    configFn: function(_, param) {
        var accessToken = param.accessToken;
        return {
            method: "get",
            url: "".concat(endPoint.PES, "/gen-doc-number"),
            headers: {
                Authorization: "Bearer ".concat(accessToken)
            }
        };
    },
    onError: function(error, param) {
        var modalObj = param.modalObj, setModalObj = param.setModalObj;
        var getStatus = function(err) {
            return http.isAxiosError(err) && err.response ? err.response.status : 500;
        };
        var getMessage = function(err) {
            return http.isAxiosError(err) && err.response ? err.response.data.message : "เกิดข้อผิดพลาด\nหรือเครือข่ายขัดข้อง";
        };
        setModalObj === null || setModalObj === void 0 ? void 0 : setModalObj(_object_spread_props(_object_spread({}, modalObj), {
            visible: true,
            subTitle: "รหัส ".concat(getStatus(error)),
            navigateDirection: undefined,
            title: getMessage(error)
        }));
    }
});
export var clearGenPesDocNumber = function() {
    return function(dispatch) {
        dispatch(genPesDocNumberSlice.actions.resetState());
    };
};
var _genPesDocNumberSlice_actions = genPesDocNumberSlice.actions;
export var fetchData = _genPesDocNumberSlice_actions.fetchData, fetchDataSuccess = _genPesDocNumberSlice_actions.fetchDataSuccess, fetchDataFailure = _genPesDocNumberSlice_actions.fetchDataFailure, resetState = _genPesDocNumberSlice_actions.resetState;
export default genPesDocNumberSlice.reducer;
